import { Tooltip } from '@/components/atoms/Tooltip';
import { useState } from 'react';
import Button from '@/components/Button/newButtons';
import { TrialBlurModal } from '@/components/organisms/BusinessPreview/src/components/atoms/TrialBlurModal';

function HiddenTooltip() {
	const [open, setOpen] = useState(false);
	const [hovering, setHovering] = useState(false);

	return (
		<Tooltip.Provider>
			<Tooltip.Root
				open={open}
				onOpenChange={next => {
					if (!next && hovering) return;
					setOpen(next);
				}}
			>
				<Tooltip.Trigger asChild>
					<Button
						variant="secondary"
						size="large"
						className="why-is-this-hidden-button h-full"
						card
						onClick={() => setOpen(true)}
						onPointerEnter={() => setHovering(true)}
						onPointerLeave={() => {
							setHovering(false);
						}}
					>
						Why is this hidden?
					</Button>
				</Tooltip.Trigger>
				<Tooltip.Content
					side="bottom"
					className="!important bg-transparent"
				>
					<div
						onPointerEnter={() => setHovering(true)}
						onPointerLeave={() => {
							setHovering(false);
							setOpen(false);
						}}
					>
						<TrialBlurModal isOpen />
					</div>
				</Tooltip.Content>
			</Tooltip.Root>
		</Tooltip.Provider>
	);
}

export default HiddenTooltip;
